import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  makeStyles,
} from "@material-ui/core";

import useTable from "../../../utilities/useTable";

import StatComponent from "../../stat-page/StatComponent";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(5),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const options = {
  title: "Age vs. Weight comparison",
  hAxis: { title: "Age", viewWindow: { min: 0, max: 15 } },
  vAxis: { title: "Weight", viewWindow: { min: 0, max: 15 } },
  legend: "none",
};
const data = [
  ["Age", "Weight"],
  [8, 12],
  [4, 5.5],
  [11, 14],
  [4, 5],
  [3, 3.5],
  [6.5, 7],
];

const headCells = [
  { id: "fullName", label: "Employee Name" },
  { id: "LastName", label: "Last Name" },
  { id: "mobile", label: "Mobile Number" },
  { id: "actions", label: "Actions", disableSorting: true },
];

export function Employees({
  users,
  UpdateUser,
  LoadUsers,
  cacNumber,
  roles,
  AddUser,
  userType,
  LoadLocations,
  companyId,
  LoadProducts,
}) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [userLocationOpenPopup, setuserLocationOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  var roles = roles;
  var viewRoles = ["App Owner"];

  const verifyRoles = () => {
    var i = 0;
    var actualRole = roles[0];
    for (i = 0; i < viewRoles.length; i++) {
      if (viewRoles[i] == actualRole) {
        return true;
      }
    }
    return false;
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(users.length == 0 ? users : users.userInfo, headCells, filterFn);

  useEffect(() => {
    LoadUsers(cacNumber);
    return () => {};
  }, []);

  // Load Locations
  useEffect(() => {
    LoadLocations("payload");
    return () => {};
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.firstName.toLowerCase().includes(target.value)
          );
      },
    });
  };

  const addOrEdit = (employee, resetForm) => {
    if (employee.id === 0) AddUser(employee);
    else var data = { ...employee, userId: employee.id };
    UpdateUser(data);
    resetForm();
    setOpenPopup(false);
    setAddOpenPopup(false);
    setNotify({
      isOpen: true,
      message: "Submitted Successfully",
      type: "success",
    });
  };

  const addEmployee = (employee, resetForm) => {
    AddUser(employee);
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };
  const userLocationInPopup = (item) => {
    setRecordForEdit(item);
  };

  return (
    <>
      <StatComponent />
      <div className="container">
        <ToastContainer />
        <div>
          <div></div>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    buttonloader: state.utilityReducer.buttonloader,
    user: state.userReducer.user,
    cacNumber: state.userReducer.cacNumber,
    users: state.usersReducer.users,
    userType: state.userReducer.userType,
    roles: state.persistReducer.roles,
    companyId: state.persistReducer.companyId,
  };
}
const mapDispatchToProps = (dispatch) => ({
  UpdateUser(payload) {
    dispatch({ type: "UPDATE_USER", payload });
  },
  LoadLocations(payload) {
    dispatch({ type: "LOAD_LOCATIONS", payload });
  },
  LoadUsers(payload) {
    dispatch({ type: "LOAD_USERS", payload });
  },
  AddUser(payload) {
    dispatch({ type: "ADD_USER", payload });
  },

  LoadDetails(payload) {
    dispatch({ type: "LOGIN_USER", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Employees);
